import { View } from 'react-native';

import { numberToArray } from '../../Helper';
import themeStyle from '../../Theme/styles';

import Ticket from './Ticket';
import { OrderDetails } from '../../RTK/api/orders/types';

const TicketsComponentWeb = ({ data }: { data: OrderDetails }) => {
  return (
    <View style={[themeStyle.flex1, themeStyle.justifyContentCenter]}>
      {numberToArray(data.items[0]?.quantity).map((_, i) => {
        // First card: no tilt or shift
        let tiltAngle = '0deg';
        let translateX = 0;

        if (i > 0) {
          const tiltValue = 10; // degrees of rotation
          const shiftValue = 65; // px shift left or right

          const isRight = i % 2 === 1;
          tiltAngle = isRight ? `${tiltValue}deg` : `-${tiltValue}deg`;
          translateX = isRight ? shiftValue : -shiftValue;
        }

        return (
          <View
            key={i}
            style={{
              position: i > 0 ? 'absolute' : 'relative',
              left: 0,
              right: 0,
              zIndex: data.items[0]?.quantity - i,
              transform: [{ rotate: tiltAngle }, { translateX: translateX }],
            }}
          >
            <Ticket
              {...data}
              contentContainerStyle={{ transform: [{ scale: 0.7 }] }}
              index={i}
              readOnly
              withShadow
            />
          </View>
        );
      })}
    </View>
  );
};

export default TicketsComponentWeb;
